import IBuilding from "../building";
import IFloor from "../floor";
import ILocal from "../local";
import IProfile from "../profile";
import ITask from "../task";

export enum EPeriodicStatus {
    Todo,
    Accepted,
    Refused,
    ToVerify = 98859,
    Overdue,
}
export type EPeriodicStatusKeysType = keyof typeof EPeriodicStatus;

export default interface IPeriodic {
    id: number;
    userId: number;
    taskId: number;
    taskName?: string;
    username: string;
    executionDate: Date;
    scheduleDate: Date;
    status: EPeriodicStatus;
    reason: null;
    picture: null;
}

export interface PeriodicDetails {
    id: number;
    task: ITask;
    profile: IProfile;
    building: IBuilding;
    floor: IFloor;
    local: ILocal;
    schedule: IPeriodic;
}

export interface PeriodicDisplayDate {
    status: EPeriodicStatus;
    scheduleDate: Date;
    id: number;
    userName: string;
    executionDate: Date;
}

export const DEFAULT_PERIODIC_DISPLAY: PeriodicDisplayDate = {
    status: EPeriodicStatus.Todo,
    scheduleDate: new Date(),
    id: 0,
    userName: "",
    executionDate: new Date(),
};
export interface PeriodicDisplay {
    id: string;
    room: ILocal;
    building: string;
    floor: string;
    profile: string;
    task: ITask;
    cleaningDate: PeriodicDisplayDate;
}
